import classNames from 'classnames';

import {UserStatus} from '@time-webkit/all/types/general';

import styles from './styles.module.css';

type Props = {
    status: UserStatus;
    size: number;
    className?: string;
};

const statusClassnameMap: {[key in UserStatus]: string} = {
    online: styles.online,
    offline: styles.offline,
    away: styles.away,
    dnd: styles.dnd,
};

export const AvatarStatus = ({status, className, size}: Props) => {
    return (
        <span
            style={{
                width: size + 'px',
                height: size + 'px',
            }}
            className={classNames(className, styles.status_icon, statusClassnameMap[status])}
        />
    );
};
